<template>
  <div :ref="chartRefId" :style="{ width: '100%', height: '400px' }"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'BarChart',
  props: {
    dataInput: {
      type: Array,
      required: true
      // Example: [{ variable: 'Math', value: 85 }, { variable: 'Science', value: 92 }]
    }
  },
  data() {
    return {
      chartRefId: `bar-chart-${this._uid}`,
      chartInstance: null
    };
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      const chartEl = this.$refs[this.chartRefId];
      if (!chartEl) return;

      this.chartInstance = echarts.init(chartEl);

      const categories = this.dataInput.map(d => d.variable);
      const values = this.dataInput.map(d => Number(d.value));

      const options = {
        title: {
          text: 'Bar Chart'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' }
        },
        xAxis: {
          type: 'category',
          data: categories,
          name: 'Category',
          axisLabel: { rotate: 30 }
        },
        yAxis: {
          type: 'value',
          name: 'Value'
        },
        series: [
          {
            type: 'bar',
            data: values,
            barWidth: '60%',
            itemStyle: {
              color: '#FFD38A'
            }
          }
        ]
      };

      this.chartInstance.setOption(options);
      window.addEventListener('resize', this.resizeChart);
    },
    resizeChart() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
    getChartInstance() {
      return this.chartInstance;
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.resizeChart);
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  }
};
</script>
